import AbstractRestApi from '@/api/RestApi/AbstractRestApi'

class CompanyDeliveryRule extends AbstractRestApi {
    getBaseUrl() {
        return '/api/v1/company-delivery-rule-overrides'
    }
}

export default new CompanyDeliveryRule()
